<template>
  <div class="icon-box">
    <a href="#">
      <div class="layer" @click="businessarea('1')">
        <i></i>
        <i></i>
        <i></i>
        <i
          ><svg
            t="1695352572788"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="1607"
            :width="imgwidth"
            :height="imgheight"
          >
            <path
              d="M899.915294 440.520784l-135.93098-120.470588v-101.596863a15.058824 15.058824 0 0 0-30.117647 0v75.695687l-177.894902-156.812549a54.613333 54.613333 0 0 0-72.081569 0L140.54902 440.520784a54.412549 54.412549 0 0 0 35.940392 95.372549h13.05098V762.980392a115.651765 115.651765 0 0 0 115.450981 115.450981h430.481568A115.651765 115.651765 0 0 0 850.923922 762.980392V535.893333H863.372549a54.412549 54.412549 0 0 0 35.940392-95.372549z m-13.05098 49.392941a23.893333 23.893333 0 0 1-22.889412 15.861961h-28.109804a15.259608 15.259608 0 0 0-15.058823 15.058824V762.980392a85.333333 85.333333 0 0 1-85.333334 85.333333H304.38902A85.534118 85.534118 0 0 1 219.055686 762.980392V520.83451a15.058824 15.058824 0 0 0-15.058823-15.058824h-28.109804a23.491765 23.491765 0 0 1-22.688628-15.861961A23.893333 23.893333 0 0 1 160.627451 463.008627L503.767843 160.627451a24.294902 24.294902 0 0 1 32.326275 0l343.943529 302.381176a23.893333 23.893333 0 0 1 6.826667 26.905098z"
              fill="#12b7f5"
              p-id="1608"
            ></path>
            <path
              d="M646.324706 551.755294h-111.23451v-111.435294a15.058824 15.058824 0 0 0-30.117647 0v111.435294H393.537255a15.058824 15.058824 0 0 0 0 30.117647h111.435294v111.23451a15.058824 15.058824 0 0 0 30.117647 0V582.27451h111.23451a15.058824 15.058824 0 0 0 0-30.117647z"
              fill="#12b7f5"
              p-id="1609"
            ></path></svg
        ></i>
      </div>
      <div class="text">村镇饮用水</div>
    </a>
    <a href="#">
      <div class="layer" @click="businessarea('2')">
        <i></i>
        <i></i>
        <i></i>
        <i
          ><svg
            t="1695353088860"
            class="icon"
            viewBox="0 0 1144 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5307"
            :width="imgwidth"
            :height="imgheight"
          >
            <path
              d="M1105.736388 651.916881H736.957532a38.69973 38.69973 0 0 1-38.686873-38.648302V89.022236a38.686873 38.686873 0 0 1 38.686873-38.571159h368.778856a38.674016 38.674016 0 0 1 38.661159 38.571159v524.246343a38.686873 38.686873 0 0 1-38.661159 38.648302z m-348.323284-59.142444h327.854856V109.516379h-327.854856z"
              fill="#2aae67"
              p-id="5308"
            ></path>
            <path
              d="M718.649089 702.303673H577.555787a38.686873 38.686873 0 0 1-38.674016-38.648302V38.648302A38.69973 38.69973 0 0 1 577.555787 0h141.093302a38.69973 38.69973 0 0 1 38.674015 38.648302v625.007069a38.69973 38.69973 0 0 1-38.674015 38.648302z m-120.63773-59.142445h100.182158V59.129588h-100.182158z"
              fill="#2aae67"
              p-id="5309"
            ></path>
            <path
              d="M721.1305 163.721715m0.642852 0l137.943324 0q0.642853 0 0.642853 0.642853l0 44.202549q0 0.642853-0.642853 0.642852l-137.943324 0q-0.642853 0-0.642852-0.642852l0-44.202549q0-0.642853 0.642852-0.642853Z"
              fill="#2aae67"
              p-id="5310"
            ></path>
            <path
              d="M708.157733 417.507088m0.642853 0l119.146312 0q0.642853 0 0.642852 0.642852l0 44.202549q0 0.642853-0.642852 0.642853l-119.146312 0q-0.642853 0-0.642853-0.642853l0-44.202549q0-0.642853 0.642853-0.642852Z"
              fill="#2aae67"
              p-id="5311"
            ></path>
            <path
              d="M703.876334 495.292259m0.642853 0l310.176408 0q0.642853 0 0.642853 0.642853l0 44.176835q0 0.642853-0.642853 0.642852l-310.176408 0q-0.642853 0-0.642853-0.642852l0-44.176835q0-0.642853 0.642853-0.642853Z"
              fill="#2aae67"
              p-id="5312"
            ></path>
            <path
              d="M190.712771 898.245163l-45.501111-0.167142c1.285705-332.316253 71.215218-566.777475 207.718551-696.852282 106.649256-101.712148 214.069935-98.485027 218.865616-98.086458l-1.799987 45.411111c-3.857116-0.154285-94.345056-2.288555-186.902982 86.797966-86.952251 83.532274-190.721527 266.385285-192.380087 662.896805zM464.028007 885.760964c-1.65856-256.742495 81.385147-284.51373 98.047888-287.599422l7.997087 44.793973-3.934258-22.358415 5.32282 22.101274c-0.642853 0.205713-63.269559 22.551271-61.86814 242.754021z"
              fill="#2aae67"
              p-id="5313"
            ></path>
            <path
              d="M341.821717 434.632683a22.744127 22.744127 0 0 1-19.439864-34.546902c62.536707-103.087852 138.277607-126.461975 141.427585-127.387683a22.746698 22.746698 0 1 1 13.037051 43.58541c-1.118564 0.359997-63.076703 20.776998-115.597765 107.394965a22.769841 22.769841 0 0 1-19.427007 10.95421zM258.070873 871.811062a22.769841 22.769841 0 0 1-22.5127-19.607007c-12.407056-89.292234 27.462666-234.718363 29.146939-240.851177a22.756984 22.756984 0 0 1 43.855409 12.137059c-0.398569 1.414276-39.04687 142.507577-27.938377 222.427019a22.756984 22.756984 0 0 1-19.362722 25.714107 23.528407 23.528407 0 0 1-3.188549 0.179999z"
              fill="#2aae67"
              p-id="5314"
            ></path>
            <path
              d="M143.681671 907.2451c-43.14827 0-87.595103-13.589905-132.517647-40.589717a22.747984 22.747984 0 1 1 23.412693-39.008299c45.436826 27.282667 89.279377 38.275447 130.344805 32.656915 18.539871-2.571411 28.876941-7.354234 40.834001-12.857053 13.898474-6.428527 29.699793-13.87276 56.98246-17.241308 43.161128-5.374248 69.505229 4.834252 94.859338 14.721325 20.85414 8.112801 40.48686 15.775604 73.040919 16.032746 30.329788-0.334283 42.325419-5.554247 58.936732-12.857053 18.552728-8.2028 39.57401-17.485592 80.536581-18.784155 42.672559-1.285705 66.856677 7.598518 87.955101 15.428464 19.799862 7.379949 36.899743 13.911332 70.958076 13.114194 30.946927-0.552853 46.208249-6.261385 63.873841-12.857053 20.571285-7.714232 44.048264-16.508456 88.713667-14.83704 31.756921 1.079992 65.403829 6.749953 121.164869 16.148459 26.999812 4.551397 49.319656 8.884224 64.966689 12.034202a22.756984 22.756984 0 0 1-8.999937 44.613974c-15.274179-3.111407-37.144027-7.354234-63.488128-11.77706-53.922481-9.07708-86.463683-14.567041-115.173483-15.569892-35.871178-1.00285-52.341063 4.88568-71.240931 11.995631s-40.255433 15.029895-79.045163 15.775604c-42.518275 0.43714-66.573821-8.138515-87.620818-15.955603-19.748434-7.354234-36.874029-13.615619-70.713792-12.625626-32.142633 1.028564-47.391098 7.714232-63.565271 14.914182-18.167016 7.971373-39.098299 16.058459-77.669458 16.765597-40.859715-0.308569-66.53525-10.285643-89.202235-19.131295s-40.654002-15.814175-72.796635-11.969917c-20.121288 2.571411-30.856928 7.508519-43.315412 13.332765-13.371335 6.235671-28.529801 13.30705-53.922481 16.791311a206.45856 206.45856 0 0 1-27.308381 1.735702zM142.460251 1024c-40.229719 0-81.783715-12.021345-123.697709-35.845464a22.744127 22.744127 0 1 1 21.586992-40.036864l0.887137 0.501425c38.48116 21.85699 75.766614 31.782635 111.033511 29.571223 23.51555-1.491418 38.661159-7.585661 56.211037-14.61847 20.661284-8.318513 44.073978-17.729876 80.716579-17.999874 32.052634-0.527139 47.571097 6.531383 63.153846 13.024195 12.484199 5.142821 24.286973 10.07993 47.879666 12.458484 36.565459 3.574261 56.403892-3.484261 79.533731-11.712775s49.718225-17.704162 91.349362-16.945596c45.655396 0.578567 69.916655 12.445627 89.395091 21.998417 17.678448 8.63994 31.474066 15.299893 62.073853 13.731333 32.412631-1.889987 51.338213-11.571348 71.395216-21.934132 24.95554-12.857053 50.811074-26.009819 94.795053-19.928433 17.999874 2.571411 30.445502 7.10995 43.546839 11.995631a345.044736 345.044736 0 0 0 61.610999 17.614163 516.673539 516.673539 0 0 0 75.17519 9.11565 22.756984 22.756984 0 0 1 21.664135 23.785549 23.142696 23.142696 0 0 1-23.798406 21.612706 562.663218 562.663218 0 0 1-81.822286-9.912788 391.085843 391.085843 0 0 1-68.733807-19.568435c-12.059916-4.487112-20.789855-7.714232-33.904049-9.578504-29.661222-3.934258-45.693967 4.049972-67.730956 15.351321-21.201281 10.877067-47.571097 24.428401-89.575089 26.871241-42.428275 2.571411-64.825262-8.54994-84.68941-18.282729-17.807019-8.691368-34.521188-16.919882-69.98094-17.357022-33.59548-0.192856-54.166765 6.76281-75.509473 14.361328-25.932676 9.218507-52.713918 18.719869-99.333593 14.142759-30.316931-3.047122-47.223956-10.092787-60.826719-15.762748s-24.29983-10.607069-45.411112-9.501362c-27.964091 0.141428-44.665403 6.865666-64.028124 14.579898-18.514157 7.431377-39.48401 15.852747-70.276653 17.807019-4.204256 0.321426-8.447084 0.462854-12.689911 0.462854z"
              fill="#2aae67"
              p-id="5315"
            ></path></svg
        ></i>
      </div>
      <div class="text">生活污水处理</div>
    </a>
    <a href="#">
      <div class="layer" @click="businessarea('3')">
        <i></i>
        <i></i>
        <i></i>
        <i
          ><svg
            t="1695353277692"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="11784"
            :width="imgwidth"
            :height="imgheight"
          >
            <path
              d="M507.328 686.272a164.288 164.288 0 0 1-109.12-288.256l0.64-0.576 108.48-108.032 108.8 108.416a164.352 164.352 0 0 1-108.8 288.448z m0-354.304L417.92 420.672a135.552 135.552 0 1 0 178.56 0l-3.456-3.2-85.76-85.504z"
              fill="#e79115"
              p-id="11785"
            ></path>
            <path
              d="M281.536 316.608l-26.048-15.04 112-192.896C408.448 38.528 463.424 0 523.008 0c59.648 0 114.752 38.528 155.52 108.672L787.2 295.68l-26.048 15.04-108.8-186.944C617.472 63.424 571.456 30.144 523.136 30.144c-48.384 0-94.464 33.28-129.664 93.632L281.536 316.608z"
              fill="#e79115"
              p-id="11786"
            ></path>
            <path
              d="M799.04 347.968l-192-79.616 11.648-27.776 155.584 64.512 21.632-166.08 29.824 3.84-26.688 205.12z m-343.552 525.44H231.36c-81.664 0-143.04-28.416-172.736-80-29.632-51.584-23.36-118.208 17.28-187.968l108.608-187.072 26.048 15.104-108.672 187.072c-34.944 60.096-41.024 116.096-17.216 157.568 23.872 41.472 76.224 65.152 146.688 65.152h224.128v30.08z"
              fill="#e79115"
              p-id="11787"
            ></path>
            <path
              d="M220.8 591.04L199.168 424.96 43.52 489.472 32 461.696l192.064-79.68 26.56 205.184-29.888 3.84z m362.688 278.208v-30.08h217.344c70.528 0 122.624-23.168 146.624-64.96 24-41.792 17.856-97.92-17.152-158.08l-112-192.448 25.984-15.104 112 192.896c40.704 69.76 46.784 136.512 17.28 187.776-29.504 51.264-90.816 80-172.736 80H583.488z"
              fill="#e79115"
              p-id="11788"
            ></path>
            <path
              d="M697.6 978.752l-165.568-125.568 165.632-125.44 18.112 24-133.952 101.504 133.952 101.568z"
              fill="#e79115"
              p-id="11789"
            ></path>
          </svg>
        </i>
      </div>
      <div class="text">中水回用</div>
    </a>
    <a href="#">
      <div class="layer" @click="businessarea('4')">
        <i></i>
        <i></i>
        <i></i>
        <i
          ><svg
            t="1695353685796"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="15984"
            :width="imgwidth"
            :height="imgheight"
          >
            <path
              d="M88.8 650.4c-3.2 0-6.4-0.8-8.8-2.4-4.8-3.2-7.2-8.8-7.2-14.4l27.2-470.4c0.8-8.8 7.2-15.2 16-15.2H248c8.8 0 15.2 6.4 16 15.2l22.4 378.4c0 6.4-3.2 12-8.8 15.2L96 648.8c-2.4 0.8-4.8 1.6-7.2 1.6z m42.4-469.6L106.4 608l147.2-74.4-20.8-352.8H131.2z"
              fill="#2075fd"
              p-id="15985"
            ></path>
            <path
              d="M1004 993.6H20c-8.8 0-16-7.2-16-16V669.6c0-6.4 3.2-11.2 8.8-14.4l344.8-174.4c4.8-2.4 11.2-2.4 16 0.8 4.8 3.2 8 8 8 13.6V584l189.6-103.2c4.8-2.4 11.2-2.4 16 0 4.8 3.2 8 8 8 13.6V584l189.6-103.2c4.8-2.4 11.2-2.4 16 0 4.8 3.2 8 8 8 13.6V584l189.6-103.2c4.8-2.4 11.2-2.4 16 0 4.8 3.2 8 8 8 13.6v483.2c-2.4 8.8-9.6 16-18.4 16z m-968-32h952v-440L798.4 624.8c-4.8 2.4-11.2 2.4-16 0s-8-8-8-13.6V522.4L585.6 624.8c-4.8 2.4-11.2 2.4-16 0-4.8-3.2-8-8-8-13.6V522.4L372 624.8c-4.8 2.4-11.2 2.4-16 0-4.8-3.2-8-8-8-13.6V520.8l-312 158.4v282.4zM195.2 149.6c-8.8 0-16-7.2-16-16V78.4c0-7.2 4.8-13.6 12-15.2l116-32.8c8.8-2.4 17.6 2.4 20 11.2 2.4 8.8-2.4 17.6-11.2 20l-104.8 29.6v43.2c0 8-7.2 15.2-16 15.2zM394.4 102.4c-7.2 0-13.6-4.8-15.2-12-2.4-8.8 2.4-17.6 11.2-20l116-32.8c8.8-2.4 17.6 2.4 20 11.2 2.4 8.8-2.4 17.6-11.2 20l-116 32.8c-2.4 0.8-4 0.8-4.8 0.8z"
              fill="#2075fd"
              p-id="15986"
            ></path>
            <path
              d="M895.2 813.6h-92.8c-4.8 0-8-3.2-8-8V704.8c0-4.8 3.2-8 8-8h92.8c4.8 0 8 3.2 8 8v101.6c0 4-3.2 7.2-8 7.2z m-84-16h76.8V712.8h-76.8v84.8zM628.8 813.6H536.8c-4.8 0-8-3.2-8-8V704.8c0-4.8 3.2-8 8-8h92.8c4.8 0 8 3.2 8 8v101.6c-0.8 4-4 7.2-8.8 7.2z m-84-16h76.8V712.8h-76.8v84.8zM362.4 813.6H269.6c-4.8 0-8-3.2-8-8V704.8c0-4.8 3.2-8 8-8h92.8c4.8 0 8 3.2 8 8v101.6c0 4-3.2 7.2-8 7.2z m-84.8-16h76.8V712.8h-76.8v84.8z"
              fill="#2075fd"
              p-id="15987"
            ></path></svg
        ></i>
      </div>
      <div class="text">工业给排水处理</div>
    </a>
    <a href="#">
      <div class="layer" @click="businessarea('5')">
        <i></i>
        <i></i>
        <i></i>
        <i
          ><svg
            t="1695353874263"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="20945"
            :width="imgwidth"
            :height="imgheight"
          >
            <path
              d="M677.236364 735.418182c-67.490909 2.327273-132.654545 23.272727-190.836364 62.836363 0 0-86.109091 62.836364-167.563636 62.836364-90.763636 0-181.527273-62.836364-181.527273-62.836364v-58.181818s90.763636 62.836364 181.527273 62.836364c81.454545 0 167.563636-83.781818 167.563636-83.781818s90.763636-67.490909 190.836364-67.490909c90.763636 0 190.836364 62.836364 190.836363 62.836363v83.781818c0-2.327273-104.727273-62.836364-190.836363-62.836363z m-11.636364-186.181818c11.636364-25.6 16.290909-53.527273 18.618182-81.454546V465.454545c88.436364 2.327273 186.181818 62.836364 186.181818 62.836364v83.781818s-104.727273-62.836364-190.836364-62.836363h-13.963636z m-9.309091-162.909091c-11.636364-25.6-25.6-51.2-39.563636-79.127273 18.618182-4.654545 37.236364-6.981818 58.181818-6.981818 90.763636 0 188.509091 62.836364 188.509091 62.836363v83.781819s-100.072727-62.836364-186.181818-62.836364h-23.272728l2.327273 2.327273z m-146.618182 272.290909c-95.418182 0-167.563636-90.763636-167.563636-183.854546s160.581818-276.945455 160.581818-321.163636c0 0 160.581818 260.654545 160.581818 316.509091 2.327273 86.109091-72.145455 188.509091-153.6 188.509091z m-188.509091-151.272727c-90.763636 0-181.527273-62.836364-181.527272-62.836364v-58.181818s90.763636 62.836364 181.527272 62.836363h4.654546c-2.327273 6.981818-2.327273 16.290909-2.327273 23.272728 0 11.636364 2.327273 23.272727 2.327273 34.909091h-4.654546zM372.363636 605.090909c13.963636 16.290909 30.254545 30.254545 48.872728 41.890909-30.254545 13.963636-65.163636 20.945455-97.745455 23.272727-90.763636 0-181.527273-60.509091-181.527273-60.50909v-58.181819s90.763636 60.509091 181.527273 60.509091c13.963636 2.327273 32.581818-2.327273 48.872727-6.981818z"
              fill="#2d8dc5"
              p-id="20946"
            ></path></svg
        ></i>
      </div>
      <div class="text">综合水生态建设</div>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgwidth: 70,
      imgheight: 70,
      screenWidth: null,
    };
  },

  mounted() {
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  watch: {
    screenWidth(n, o) {
      // console.log("n", n);
      if (n < 660) {
        this.imgwidth = 50;
        this.imgheight = 50;
      } else {
        this.imgwidth = 70;
        this.imgheight = 70;
      }
    },
  },
  methods: {
    businessarea(data) {
      if (data == "1") {
        this.$router.push("/business/czyys");
      } else if (data == "2") {
        this.$router.push("/business/czshws");
      } else if (data == "3") {
        this.$router.push("/business/zshy");
      } else if (data == "4") {
        this.$router.push("/business/gyjps");
      } else if (data == "5") {
        this.$router.push("/business/hjzl");
      }
    },
  },
};
</script>

<style>
.icon-box {
  display: flex;
  flex-direction: row;
}
.icon-box a {
  color: #fff;
  margin: 0 30px;
  text-decoration: none;
  position: relative;
}
.icon-box a .layer {
  width: 70px;
  height: 70px;
  transition: 0.3s;
}
.icon-box a .layer i {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid var(--c);
  border-radius: 6px;
  transition: 0.3s;
}
.icon-box a .text {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 5px;
  opacity: 0;
  text-align: center;
  color: var(--c);
  transition: 0.3s;
  font-size: 14px;
}
.icon-box a:hover .text {
  bottom: -35px;
  opacity: 1;
}
.icon-box a:hover .layer {
  /* 旋转35度并倾斜20度 */
  transform: rotate(-35deg) skew(20deg);
}
.icon-box a:hover .layer i:nth-child(1) {
  opacity: 0.2;
  transform: translate(0, 0);
}
.icon-box a:hover .layer i:nth-child(2) {
  opacity: 0.4;
  transform: translate(5px, -5px);
}
.icon-box a:hover .layer i:nth-child(3) {
  opacity: 0.6;
  transform: translate(10px, -10px);
}
.icon-box a:hover .layer i:nth-child(4) {
  opacity: 0.8;
  transform: translate(15px, -15px);
}
.icon-box a:hover .layer i:nth-child(5) {
  opacity: 1;
  transform: translate(20px, -20px);
}
.icon-box a:nth-child(1) .layer i,
.icon-box a:nth-child(1) .text {
  --c: #12b7f5;
}
.icon-box a:nth-child(2) .layer i,
.icon-box a:nth-child(2) .text {
  --c: #2aae67;
}
.icon-box a:nth-child(3) .layer i,
.icon-box a:nth-child(3) .text {
  --c: #e79115;
}

.icon-box a:nth-child(4) .layer i,
.icon-box a:nth-child(4) .text {
  --c: #2075fd;
}
.icon-box a:nth-child(5) .layer i,
.icon-box a:nth-child(5) .text {
  --c: #2d8dc5;
}
.icons {
  text-align: center;
}
@media (max-width: 660px) {
  .icon-box a .layer {
    width: 50px;
    height: 50px;
  }
  .icon-box a {
    margin: 0 10px;
  }
}
</style>
